"use client";

import { useState } from "react";
import { X } from "lucide-react";

// Dev container only — see app/layout.tsx. A visual cue so dev is never
// mistaken for goforcoach.com prod at a glance; dismissible since it sits on
// top of everything and a dev session may run for hours.
export function DevStripe() {
  const [dismissed, setDismissed] = useState(false);
  if (dismissed) return null;
  return (
    <div className="fixed inset-x-0 top-0 z-50 flex h-1.5 items-stretch bg-red-600">
      <button
        type="button"
        aria-label="Dismiss dev environment indicator"
        onClick={() => setDismissed(true)}
        className="pointer-events-auto absolute top-0 right-1 flex h-4 w-4 -translate-y-px items-center justify-center rounded-b-sm bg-red-600 text-white"
      >
        <X className="size-3" aria-hidden />
      </button>
    </div>
  );
}
